module.exports = __webpack_public_path__ + "img/shortland.b976628d.svg";